import { useCallback } from 'react';

import { NotificationsDropdown } from 'components/NotificationsDropdown/NotificationsDropdown';
import { markNotificationsAsViewed } from 'modules/main/store/ducks/userNotifications.actions';
import { useMainDispatch } from 'modules/main/store/hooks/useMainDispatch';
import { useMainSelector } from 'modules/main/store/hooks/useMainSelector';
import { trackClicked } from 'utils/analytics/track/trackClicked';
import { trackEvent } from 'utils/analytics/track/trackEvent';
import { getMappedNotificationIds } from 'utils/userNotifications';

export function NotificationsDropdownContainer() {
  const dispatch = useMainDispatch();

  const { notifications } = useMainSelector((state) => state.userNotifications);

  const onToggle = useCallback(
    (open: boolean) => {
      trackClicked('Header Utility CTA - Notifications');

      if (open && notifications.length) {
        dispatch(
          markNotificationsAsViewed(
            notifications.flatMap((notification) =>
              getMappedNotificationIds(notification),
            ),
          ),
        );

        trackEvent('Displayed User Menu Notifications', {
          notification_types: Array.from(
            new Set(notifications.map((notification) => notification.type)),
          ),
        });
      }
    },
    [dispatch, notifications],
  );

  return (
    <NotificationsDropdown notifications={notifications} onToggle={onToggle} />
  );
}
